const MASK_GROUP = '••••';

export const maskCardNumber = (last4: string) => `${MASK_GROUP} ${last4}`;

export const maskFullCardNumber = (last4: string) =>
  `${MASK_GROUP} ${MASK_GROUP} ${MASK_GROUP} ${last4}`;

export const formatCardNumber = (number: string) => number.replace(/(\d{4})(?=\d)/g, '$1 ');

export const formatExpiry = (month: number, year: number) =>
  `${String(month).padStart(2, '0')}/${String(year % 100).padStart(2, '0')}`;
